import { protectRoutes } from 'components/desktop/_general/ProtectedRoute/ProtectedRoute';
import Detail from 'containers/desktop/ShoppingCart/Detail/ShoppingCartDetail';
import New from 'containers/desktop/ShoppingCart/New/ShoppingCartNew';
import Search from 'containers/desktop/ShoppingCart/Search/ShoppingCartSearch';

const routes = [
	{
		path: '/shoppingCart/search',
		element: <Search />,
		permissions: [],
	},
	{
		path: '/shoppingCart/detail/:id',
		element: <Detail />,
	},
	{
		path: '/shoppingCart/new',
		element: <New />,
	},
];

export default protectRoutes(routes);
